import { GroupService } from '../services/GroupService';

export function useGroupService(): GroupService {
  return new GroupService(useApiClient(), useUserStore());
}
